<template>
  <!-- 派单数据 -->
  <div>
    <HeadControl ref="headControl" :titleName="'派单数据'" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker" />
    <div class="wrap">
      <!-- 派单数量 -->
      <div class="top">
        <div class="sendOrdersNum" ref="sendOrdersNum"></div>
        <span class="sendNum">
          派单总数:<span><span class="num"> {{ count }}</span>个</span>
        </span>
      </div>

      <div class="bottom">
        <!-- 项目地区 + 驻场比例 -->
        <div class="b_left">
          <div class="projectArea">
            <div class="p_title">项目地区</div>
            <div class="areaWrap">
              <div class="item" v-for="(item,index) in projectAreaData" :key="index">
                <div class="left">
                  <div class="location">{{item.itemName}}</div>
                  <div class="number"><span class="num">{{item.count}}</span>个</div>
                </div>
                <div class="right">
                  <img :src="item.itemIcon" />
                </div>
              </div>
            </div>
          </div>
          <!-- 驻场比例 -->
          <div class="residentWrap">
            <!-- <div v-if="" class="residentPer"></div> -->
            <div class="residentPer" ref="residentPer"></div>
            <div class="leftTitle" :class="{'lastTitle': index == 1}" v-for="(item,index) in residentNumList" :key="index+2">驻场({{item}}个)</div>
            <div class="rightTitle" v-for="(item,index) in notResidentNumList" :key="index">不驻场({{item}}个)</div>
          </div>
        </div>
        <!-- 项目等级 -->
        <div class="projectGrade" ref="projectGrade"></div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadControl from "@/components/HeadControl";
import * as Urls from "@/helper/Urls";
import moment from 'moment';
export default {
  components: {},
  data() {
    return {
      orgCode: "", //组织架构
      dataRange: [], // 时间
      count: 0, //派单数量
      sendOrdersNum: {}, //派单数量折线图数据
      projectAreaData: [],  //项目地区数据
      residentData: {},   //驻场比例数据
      notResidentNumList: [],  //不驻场
      residentNumList: [],   //驻场
      projectGradeData:{},  //项目等级数据
      maxNum: 0,   //最大数量
      maxPercent: 0,   //最大百分比,
      screenWidth: document.body.clientWidth,
      isH5: false
    };
  },
  components: {
    HeadControl,
  },
  methods: {
    init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    // 获取组织架构ID
    changeVal(val) {
      this.orgCode = val;
      this.getSendOrdersNum();
      this.getProjectAreaNum();
      this.getResidentPersentData();
      this.getProjectGradeData();
    },
    // 日期改变
    changDate(val) {
      this.dataRange = val;
      this.getSendOrdersNum();
      this.getProjectAreaNum();
      this.getResidentPersentData();
      this.getProjectGradeData();
    },
    // 时间
    changePicker(val) {
      this.dataRange = val;
      this.getSendOrdersNum();
      this.getProjectAreaNum();
      this.getResidentPersentData();
      this.getProjectGradeData();
    },
    // 派单数量折线图
    initSendOrdersNum() {
      this.myChart = this.$echarts.init(this.$refs.sendOrdersNum);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "派单数量",
          padding: this.isH5 ? [24, 0, 0, 20]:[24, 0, 0, 30],
          textStyle:{
            fontWeight: 'normal',
          }
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function (params) {
            const str = `<div>${moment(params[0].axisValue).format("M月DD日")}</div>
                         <div>派单数量：${params[0].data}个</div>`;
            return `<div style="padding: 5px 10px; font-size: 12px">${str}</div>`;
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.sendOrdersNum.xAxis.data,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: this.sendOrdersNum.series[0].data.reduce((a,b)=>a+b) === 0 ? true : false,
            lineStyle: {
              color: '#ddd',
            },
          },
          splitLine: {
            show: this.sendOrdersNum.series[0].data.reduce((a,b)=>a+b) === 0 ? false : true,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            interval: parseInt(this.sendOrdersNum.xAxis.data.length / 10),
            color: '#666',
            show: this.isH5 ? false:true,
            margin: 20
          },
        },
        yAxis: {
          type: "value",
          show: this.sendOrdersNum.series[0].data.reduce((a,b)=>a+b) === 0 ? false : true,
          name: "数量(个)",
          minInterval: 1,
          nameGap: 16,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#ddd'
            }
          },
        },
        grid: {
          left: this.isH5 ? 40 : 60,
          right: this.isH5 ? 30 : 60,
          top: 95,
          bottom: this.isH5? 30 : 60,
        },
        series: [
          {
            data: this.sendOrdersNum.series[0].data,
            type: "line",
            smooth: true,
            symbol: "circle",
            // symbolSize: 3,
            lineStyle: {
              normal: {
                color: "#5ebbff",
                opacity: this.sendOrdersNum.series[0].data.reduce((a,b)=>a+b) === 0 ? 0 : 1
              },
            },
            itemStyle: {
              normal: {
                color: "#57B9FF",
                borderType: "solid",
                borderColor: "#fff",
                opacity: this.sendOrdersNum.series[0].data.reduce((a,b)=>a+b) === 0 ? 0 : 1
              },
            },
            areaStyle: {
              normal: {
                color: "#e6f5ff",
              },
            },
          },
        ],
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.myChart.resize({width: this.screenWidth - 24}) : this.myChart.resize();
      });
      this.isH5 ? this.myChart.resize({width: this.screenWidth - 24}) : this.myChart.resize();
    },
    // 驻场比例柱状图
    initResidentPerChart() {
      this.residentPerChart = this.$echarts.init(this.$refs.residentPer);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "驻场比例",
          padding: this.isH5 ? [24, 0, 0, 20]:[24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left: 36,
          right: 34,
          bottom: 22,
          top: 68,
        },
        xAxis: {
          show: false,
          type: "value",
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            // console.log('aa', params)
            let index = params.dataIndex
            return `<div style="font-size:14px; padding:4px;">
                         <div>${params.seriesName}：${this.residentData.series[index].data[params.seriesIndex]}个</div>
                         <div>占比：${params.value}%</div>
                     </div>`
          }
        },
        yAxis: [
          {
            // 总承包项目   重点项目
            type: "category",
            data: this.residentData.yAxis.data,
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              align: "left",
              padding: [-50, -40, -10, 10],
              fontSize: 14,
              color: "#333",
              rich: {}
            },
          },
          {
            // 蓝色的百分比  驻场
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            position: "left",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#57b9ff",
                fontSize: "14",
              },
              align: 'left',
              padding: this.isH5 ? [30, 140, -10, 90]:[30, 140, -10, 100],
              formatter: "{value}%",
              rich: {}
            },
            data: this.epcProject,
          },
          {
            // 橙色的百分比   不驻场
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            position: "right",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#FFB96E",
                fontSize: "14",
              },
              padding: this.isH5 ? [40, -100, 0, -20]:[40, -100, 0, -40],
              formatter: "{value}%",
              rich: {}
            },
            data: this.largeProject,
          }
        ],
        series: [
          {
            name: "驻场",
            type: "bar",
            zlevel: 1,
            show: true,
            stack: "total",
            itemStyle: {
              normal: {
                barBorderRadius: [10, 0, 0, 10],
                color: "#57b9ff",
                label: {
                  show: false,
                },
              },
            },
            barWidth: 10,
            barGap: "-100%",
            data: this.epcProject
          },
          {
            name: "不驻场",
            type: "bar",
            zlevel: 1,
            stack: "total",
            itemStyle: {
              normal: {
                barBorderRadius: [0, 10, 10, 0],
                color: "#FFB96E",
                label: {
                  show: false,
                },
              },
            },
            label: {
              show: true,
            },
            barWidth: 10,
            barGap: "-100%",
            data: this.largeProject,
          },
          {
            type: "bar",
            silent: true,
            barWidth: 10,
            barGap: "-100%",
            data: [100, 100],
            itemStyle: {
              normal: {
                color: "#eeeeee",
                barBorderRadius: 10,
              },
            },
          },
        ],
      };
      this.residentPerChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.residentPerChart.resize({width: this.screenWidth - 24}) : this.residentPerChart.resize();
      });
      this.isH5 ? this.residentPerChart.resize({width: this.screenWidth - 24}) : this.residentPerChart.resize();
    },
    // 项目等级柱状折线图
    initProjectGradeChart() {
      this.projectGradeChart = this.$echarts.init(this.$refs.projectGrade);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "项目等级",
          padding: this.isH5 ? [24, 0, 0, 20]:[24, 0, 0, 30],
          textStyle:{
            fontWeight: 'normal'
          }
        },
        grid: {
          left:  this.isH5? 70:80,
          top: 112,
          right:  this.isH5? 60:63,
          bottom: 57,
        },
        tooltip: {
          trigger: "axis",
          formatter: (params)=>{
            let message = ''
            params.reverse().forEach(function(item, index){
              if(item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>'
              }else{
                message += '占比: ' + item.data + '%'
              } 
            })
            return `<div style="padding: 5px 8px; font-size: 12px">${message}</div>`
          }
        },
        axisPointer:{
          type: 'none'
        },
        legend: {
          data: this.projectGradeData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ? '120' : '180',   
          itemGap: 20,// 每个icon之间的距离（单位px）
          textStyle: {
              fontSize: '13',            
              height: 10,
                rich: {
                a: {
                  verticalAlign: 'middle',
                },
              }
          },      
        },
        xAxis: [
          {
            type: "category",
            data: this.projectGradeData.xAxis.data,
            axisPointer: {
              type: 'none',
            },
            // 分隔线
            splitLine: {
              show: this.projectGradeData.series[1].data.reduce((a,b)=>a+b)===0 ? false:true,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: this.projectGradeData.series[1].data.reduce((a,b)=>a+b)===0 ? true:false,
              lineStyle:{
                color: '#ddd'
              }
            },
            axisLabel:{
              color:'#666',
            }
          },
        ],
        yAxis: [
          {
            // 数据显示
            type: "value",
            name: "百分比",
            min: 0,
            max: this.maxPercent,
            splitNumber: 5,
            interval: this.maxPercent / 5,
            axisLabel: {
              formatter: "{value}%",
              margin: 20,
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 65, 0, 0],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            show: this.projectGradeData.series[1].data.reduce((a,b)=>a+b)===0 ? false : true,
            splitLine: {
              show: false
            }
          },
          {
            type: "value",
            name: "数量（个）",
            min: 0,
            max: this.maxNum,
            splitNumber: 5,
            interval: this.maxNum / 5,
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 0, 0, 40],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              margin: 20,
              formatter: function(value) {
                return parseInt(value)
              }
            },
            splitLine:{
              lineStyle:{
                color: '#ddd'
              }
            },
            show: this.projectGradeData.series[1].data.reduce((a,b)=>a+b)===0 ? false : true,
          },
        ],
        series: [
          {
            // name: "百分比",
            name: this.projectGradeData.series[0].name,
            type: "bar",
            barWidth: "60%",
            data: this.projectGradeData.series[0].data,
            itemStyle: {
              normal: {
                color: 'rgba(87, 185, 255, 0.35)',
                borderColor:this.projectGradeData.series[1].data.reduce((a,b)=>a+b)===0 ? 'rgba(87, 185, 255, 0)':'rgba(87, 185, 255, 1)',
              },
            },
            yAxisIndex: 0,
          },
          {
            // name: "个数",
            name: this.projectGradeData.series[1].name,
            type: "line",
            symbol: "rect",
            symbolSize: 9,
            hoverAnimation: false,
            data: this.projectGradeData.series[1].data,
            itemStyle: {
              normal: {
                opacity: this.projectGradeData.series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1,
                color: "#61d9ac",
              },
              emphasis: {          //突出效果配置(鼠标置于拐点上时)
                borderWidth: 3,
                borderColor: '#61d9ac',
                color: '#61d9ac',
              },
            },
            lineStyle:{
              normal:{
                opacity: this.projectGradeData.series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1
              }
            },
            yAxisIndex: 1,
          },
        ],
      };
      this.projectGradeChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.projectGradeChart.resize({width: this.screenWidth - 24}) : this.projectGradeChart.resize();
      });
      this.isH5 ? this.projectGradeChart.resize({width: this.screenWidth - 24}) : this.projectGradeChart.resize();
    },
    // 获取派单数据
    getSendOrdersNum() {
      let url = Urls.getEchartsDispatchReportDataByTrend;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.sendOrdersNum = server_data.data;
      });
    },
    // 获取项目地区数据
    getProjectAreaNum() {
      let url = Urls.getEchartsDispatchReportDataByRegion;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.projectAreaData = server_data.data.reportList;
      });
    },
    // 获取驻场比例数据
    getResidentPersentData() {
      let url = Urls.getEchartsDispatchReportDataBySource;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.residentData = server_data.data;
      });
    },
    // 获取项目等级数据
    getProjectGradeData() {
      let url = Urls.getEchartsDispatchReportDataByGrade;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: 'CONTRACT_LEVEL'
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.projectGradeData = server_data.data;
      });
    }
  },
  watch: {
    sendOrdersNum(newVal) {
      if (newVal) {
        this.count = newVal.report.count;
        this.initSendOrdersNum();
      }
    },
    residentData(newVal) {
      if(newVal) {
        this.notResidentNumList = []
        this.residentNumList = []
        newVal.series.forEach((item) => {
          item.data.forEach((val, index)=>{
            if(index === 0) {
              this.residentNumList.push(val)
            }
            if(index === 1) {
              this.notResidentNumList.push(val)
            }
          })
        })
        this.$nextTick(function () {
  	      var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
          window.dispatchEvent(myEvent); // 事件可以在任何元素触发
        })
        this.initResidentPerChart()
      }
    },
    projectGradeData(newVal) {
      if(newVal) {
        this.maxNum = Math.ceil(Math.max(...newVal.series[1].data) / 10) * 10
        this.maxPercent = Math.ceil(Math.max(...newVal.series[0].data) / 10) * 10
        this.initProjectGradeChart();
      }
    },
  },
  computed:{
    epcProject() {
      return [this.residentData.series[0].percent[0], this.residentData.series[1].percent[0]]
    },
    largeProject(){
      return [this.residentData.series[0].percent[1], this.residentData.series[1].percent[1]]
    },
    isShowResidentChart() {
      let res = this.residentData.series.forEach((item)=>{
        item.data.map((value)=>{
          return value === 0
        })
      })
      return res
    }
  },
  mounted() {
    if(this.$route.query.identification) {
      this.isH5 = true
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth; //实时宽度
        this.screenWidth = window.screenWidth;
      })();
    }; 
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  margin-top: 0.29rem;
  .top {
    position: relative;
    box-sizing: border-box;
    margin-bottom: 24px;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.1rem;
    .sendOrdersNum {
      height: 520px;
    }
    .sendNum {
      position: absolute;
      left: 175px;
      top: 15px;
      font-size: 14px;
      color: #666;
    }
    .sendNum > span {
      color: #333;
      .num {
        font-size: 24px;
      }
    }
  }
  .bottom {
    display: flex;
    .b_left {
      width: 60%;
      margin-right: 24px;
      .projectArea {
        height: 170px;
        margin-bottom: 24px;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
        .p_title {
          border-bottom: none;
          font-size: 18px;
          color: #333;
          padding: 24px 0 0 30px;
          line-height: 18px;
        }
        .areaWrap {
          // padding: 0 30px;
          display: flex;
          justify-content: center;
          .item {
            width: 33%;
            height: 100px;
            display: flex;
            padding: 0 30px;
            justify-content: space-between;
            align-items: center;
            border-right: 1px solid #eee;
            .location {
              font-size: 14px;
              color: #666;
              margin-bottom: 17px;
            }
            .number {
              color: #333;
            }
            .num {
              font-size: 20px;
              color: #333;
              font-weight: bold;
            }
          }
          .item:last-of-type {
            border-right: none;
          }
        }
      }
      .residentWrap{
        position: relative;
        .rightTitle,.leftTitle{
          position: absolute;
          top: 111px;
          color: rgb(102,102,102);
          font-size: 14px,
        }
        .rightTitle{
          right: 82px;
        }
        .leftTitle{
          left: 50px;
        }
        .rightTitle:last-of-type{
          top: 180px;
        }
        .lastTitle{
          top: 180px;
        }
      }
      .residentPer {
        height: 226px;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
      }
    }
    .projectGrade {
      width: 39%;
      height: 420px;
      background-color: #fff;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
    }
  }
}
@media screen and (max-width: 768px){
  .wrap{
    width: calc(100% - 0.24rem);
    margin: 0 auto;
    margin-top: -0.05rem;
    .top{
      margin-bottom: 0.12rem;
      .sendOrdersNum{
        height: 3rem;
      }
    }
    .bottom{
      flex-direction: column;
      .b_left{
        width: 100%;
        margin-bottom: 0.12rem;
        .residentWrap{
          background-color: #fff !important;
          border-radius: 0.1rem;
          .rightTitle{
            right: 55px;
          }
        }
        .projectArea{
          height: auto;
          margin-bottom: 0.12rem;
          .p_title{
            padding-left: 20px;
          }
          .areaWrap{
            flex-direction: column;
            .item {
              width: auto;
              border: none;
              padding: 0;
              margin: 0 30px;
              border-bottom: 1px solid #eee;
            }
            .item:last-of-type{
              border: none;
            }
          }
        }
      }
      .projectGrade{
        border: none;
        width: 100%;
        background-color: #fff !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// sendOrdersData.vue?6e211004